import React, { memo, useEffect, useMemo, useState } from 'react'
import { CustomersMajor, PauseCircleMajor } from '@shopify/polaris-icons'
import { useSelector } from 'react-redux'
import { addS } from 'src/utils/baseUtils'
import { colors } from 'src/theme'
import { TableTab, TableTabs } from 'src/components/shared/table/table-tabs/TableTabs'
import { MCStatus } from 'src/constants/mc/enums'
import { getMCCounts } from 'src/selectors/mc'

interface Props {
  selectedTab: MCStatus
  onClick(tab: MCStatus): void
}

const MCTabsComponent = ({ selectedTab, onClick }: Props) => {
  const mcCounts = useSelector(getMCCounts)

  const [counts, setCounts] = useState<Partial<Record<MCStatus, number>>>()

  useEffect(() => {
    setCounts({
      [MCStatus.Activated]: mcCounts?.activeCount || 0,
      [MCStatus.Deactivated]: mcCounts?.inactiveCount || 0,
    })
  }, [mcCounts])

  const tabs = useMemo(() => {
    const res: TableTab<MCStatus>[] = [
      {
        value: MCStatus.Activated,
        title: 'Active',
        renderIcon: (selected: boolean) => (
          <CustomersMajor
            width={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
      {
        value: MCStatus.Deactivated,
        title: 'Deactivated',
        renderIcon: (selected: boolean) => (
          <PauseCircleMajor
            width={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
    ]

    return res.map((item) => ({
      ...item,
      dataTestId: `master-contractors-list-tab-${item.value}`,
      subtitle: counts ? `${counts[item.value] || 0} ${addS(counts[item.value] || 0, 'mc')}` : '',
    }))
  }, [counts])

  return <TableTabs tabs={tabs} selectedValue={selectedTab} onClick={onClick} />
}

export const MCTabs = memo(MCTabsComponent)
